/** Every application status a creator can hold on a brief (1 Invited … 14 Approved). */
export const ALL_APPLICATION_STATUSES: number[] = Array.from({ length: 14 }, (_, i) => i + 1);

type ApplicantRow = { applicationStatus?: number | null; creator?: { blazeFirebaseUid?: string | null } | null };

/** Firebase UID → application status, from the brief's applicants (broadcast-applicants rows). */
export function briefApplicationStatusesByCreator(rows: readonly ApplicantRow[] | null | undefined): Map<string, number> {
  const byCreator = new Map<string, number>();
  for (const row of rows ?? []) {
    const uid = row.creator?.blazeFirebaseUid;
    if (uid && typeof row.applicationStatus === 'number') {
      byCreator.set(uid, row.applicationStatus);
    }
  }
  return byCreator;
}
